<div class="collaborator-settings">
  <div class="cs-header">
    <div class="title">Collaborator Settings</div>
    <div class="sub">Manage and view your collaborators</div>
  </div>

  <div class="invite-banner">
    <div class="invite-row">
      <div class="chips-input">
        <div class="chips">
          <div class="chip" *ngFor="let e of inviteEmails; let i = index">
            <div class="avatar small">{{ e[0] | uppercase }}</div>
            <span class="chip-text">{{ e }}</span>
            <button type="button" class="chip-close" (click)="removeEmail(i)">
              <mat-icon fontIcon="close"></mat-icon>
            </button>
          </div>
          <input
            [(ngModel)]="inviteInput"
            (keyup.enter)="addEmail()"
            placeholder="Add mail.."
            class="chip-input"
          />
        </div>
      </div>

      <mat-select [(ngModel)]="inviteRole" class="role-select" disableOptionCentering>
        <mat-option value="Guest">Guest</mat-option>
        <mat-option value="Internal">Internal</mat-option>
      </mat-select>

      <button class="invite-btn" type="button" (click)="inviteCollaborators()">Invite</button>
    </div>

    <div class="personalize-row">
      <button type="button" class="personalize-btn" [class.active]="showPersonalize" (click)="togglePersonalize()">&nbsp;&nbsp;Personalize your invitation</button>
    </div>

    <div class="personalize-editor" *ngIf="showPersonalize">
      <hmt-advanced-text-area></hmt-advanced-text-area>
      <div class="editor-footer">
        <span class="muted">This message will be included in the email invite.</span>
      </div>
    </div>

    <div class="link-row">
      <button type="button" class="link-action" (click)="copyLink()">
        <mat-icon fontIcon="link"></mat-icon>
        <span>Copy invitation link</span>
      </button>
      <div class="dot">•</div>
      <div class="access">
        <span>{{ linkAccess }}</span>
        <mat-icon fontIcon="expand_more"></mat-icon>
      </div>
    </div>
  </div>

  <div class="list-section">
    <div class="section-title">Pending</div>
    <div class="table-head pending">
      <div class="col checkbox"></div>
      <div class="col name">Name</div>
      <div class="col date">Invited at</div>
      <div class="col email">Email</div>
      <div class="col type">Type</div>
      <div class="col action">Invitation</div>
    </div>

    <div class="table-row pending" *ngFor="let p of pending">
      <div class="col checkbox">
        <mat-checkbox></mat-checkbox>
      </div>
      <div class="col name with-avatar row">
        <div class="avatar pr-1" [ngStyle]="{ 'background-color': p.color }">{{ p.name[0] }}</div>
        <div class="name-text pl-1 va-c"> &nbsp;{{ p.name }}</div>
      </div>
      <div class="col date">{{ p.invitedAt | date:'MMM d, y' }}</div>
      <div class="col email"><a href="mailto:{{ p.email }}">{{ p.email }}</a></div>
      <div class="col type"><strong>{{ p.type }}</strong></div>
      <div class="col action"><button mat-button>Actions</button></div>
    </div>
  </div>

  <div class="list-section">
    <div class="section-title">Internal</div>
    <div class="table-head guests">
      <div class="col checkbox"></div>
      <div class="col name">Name</div>
      <div class="col date">Created at</div>
      <div class="col email">Email</div>
      <div class="col permission">Permission</div>
      <div class="col status">Status</div>
    </div>

    <ng-container *ngIf="guestsWithPhotos$ | async as guestsWithPhotos">
      <div class="table-row guests" *ngFor="let g of guestsWithPhotos">
        <div class="col checkbox">
          <mat-checkbox></mat-checkbox>
        </div>
        <div class="row with-avatar">
          <div class="avatar pr-1" [ngStyle]="{ 'background-color': g.color }">
            <img *ngIf="g.avatarUrl" [src]="g.avatarUrl" [alt]="g.name" class="avatar-img" />
            <span *ngIf="!g.avatarUrl">{{ g.name[0] }}</span>
          </div>
          <div class="name-text pl-1 va-c"> &nbsp;{{ g.name }}</div>
        </div>
        <div class="col date">{{ g.createdAt | date:'MMM d, y' }}</div>
        <div class="col email"><a href="mailto:{{ g.email }}">{{ g.email }}</a></div>
        <div class="col permission">
          <div class="dropdown">
            <span>{{ g.permission }}</span>
            <mat-icon fontIcon="expand_more"></mat-icon>
          </div>
        </div>
        <div class="col status">
          <div class="status-actions">
            <!-- <div class="dropdown">
              <span>{{ g.status }}</span>
              <mat-icon fontIcon="expand_more"></mat-icon>
            </div> -->
            <button mat-icon-button class="remove-btn" (click)="removeCollaborator(g.user)" matTooltip="Remove Collaborator">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
